import { cva, type VariantProps } from 'class-variance-authority';

export const ACCORDION_ITEM_VARIANTS = cva('', {
  variants: {
    borderRadius: {
      sharp:
        'rounded-none border-solid border-t border-t-transparent border-b border-b-neutral-4 dark:border-b-neutral-9 data-[open]:border-t-2 data-[open]:border-t-primary-base',
      soft: 'rounded-base overflow-hidden border border-neutral-4 dark:border-neutral-9 data-[open]:bg-neutral-2 data-[open]:border-neutral-6 dark:data-[open]:bg-neutral-9 dark:data-[open]:border-neutral-7',
    },
  },
  defaultVariants: {
    borderRadius: 'sharp',
  },
});

export const ACCORDION_TRIGGER_VARIANTS = cva('', {
  variants: {
    borderRadius: {
      sharp: 'rounded-none',
      soft: 'rounded-base',
    },
  },
  defaultVariants: {
    borderRadius: 'sharp',
  },
});

export type TAccordionVariants = VariantProps<typeof ACCORDION_ITEM_VARIANTS>;
